import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";

import "./styles/tokens.css";
import "./styles/globals.css";
import "./styles/layout.css";
import "./styles/header.css";
import "./styles/gallery.css";
import "./styles/lightbox.css";
import "./styles/bio.css";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
